import { getCarsDom, normalizeText } from "./dom.js";
import { CarsState } from "./state.js";

function getSelectedBrands(brandChecks) {
  return brandChecks
    .filter((ch) => ch.checked)
    .map((ch) => (ch.value || "").trim())
    .filter(Boolean);
}

export function applyCarsFilters() {
  const dom = CarsState.dom;
  if (!dom) return;

  const selectedBrands = new Set(getSelectedBrands(dom.brandChecks));
  const q = normalizeText(dom.searchInput?.value);

  let visible = 0;

  dom.cards.forEach((card) => {
    const brand = (card.getAttribute("data-brand") || "").trim();
    const name = normalizeText(card.getAttribute("data-name"));

    const brandOk = selectedBrands.size === 0 || selectedBrands.has(brand);
    const searchOk = !q || name.includes(q);

    const show = brandOk && searchOk;
    card.style.display = show ? "" : "none";
    if (show) visible += 1;
  });

  if (dom.resultCount) dom.resultCount.textContent = String(visible);
  if (dom.emptyState) dom.emptyState.style.display = visible === 0 ? "" : "none";
}

export function initCarsFilters() {
  const dom = getCarsDom();
  if (!dom) return;

  CarsState.dom = dom;

  // فلترة الماركات
  dom.brandChecks.forEach((ch) => ch.addEventListener("change", applyCarsFilters));

  // Pre-apply brand from URL params (e.g. ?brand=Toyota coming from home search)
  const urlBrand = new URLSearchParams(window.location.search).get("brand");
  if (urlBrand) {
    dom.brandChecks.forEach((ch) => {
      if (ch.value === urlBrand) ch.checked = true;
    });
    // Scroll brand into view in sidebar
    const checked = dom.brandChecks.find((ch) => ch.value === urlBrand);
    if (checked) {
      checked.closest("label")?.scrollIntoView({ block: "nearest" });
    }
  }

  // أول render
  applyCarsFilters();
}